import { useCallback, useState } from "react";

/** Boolean state persisted in localStorage under the given key. */
export const usePersistedFlag = (
  storageKey: string,
  defaultValue: boolean,
): [boolean, () => void] => {
  const [flag, setFlag] = useState<boolean>(() => {
    const stored = localStorage.getItem(storageKey);
    return stored === null ? defaultValue : stored === "true";
  });

  const toggleFlag = useCallback(() => {
    setFlag((previous) => {
      const next = !previous;
      localStorage.setItem(storageKey, String(next));
      return next;
    });
  }, [storageKey]);

  return [flag, toggleFlag];
};
